// Typy odpovědi GET /api/skladove-zasoby (viz api/routes/stockValue.ts).

export type StockSums = {
  /** Prodejní ceny bez DPH. */
  valueNet: number;
  /** Nákupní ceny. */
  purchase: number;
  qty: number;
  variants: number;
  variantsInStock: number;
};

export type HistoryPoint = { day: string; valueNet: number };

export type StockCategory = StockSums & {
  path: string;
  products: number;
  productsInStock: number;
  history: HistoryPoint[];
};

export type StockProduct = StockSums & {
  code: string;
  name: string;
  category: string;
  image_url: string | null;
  url: string | null;
};

export type StockValueResponse = {
  generatedAt: number;
  vatRate: number;
  totals: StockSums & { products: number; productsInStock: number };
  totalHistory: HistoryPoint[];
  categories: StockCategory[];
  products: StockProduct[];
};

const czk = new Intl.NumberFormat('cs-CZ', {
  style: 'currency',
  currency: 'CZK',
  maximumFractionDigits: 0,
});

export const fmtCzk = (n: number) => czk.format(n);

/** Podíl variant skladem v procentech (0 variant → 0). */
export function stockPct(s: { variants: number; variantsInStock: number }): number {
  return s.variants > 0 ? Math.round((s.variantsInStock / s.variants) * 100) : 0;
}

/** Barva podle podílu variant skladem — stejná škála pro pruh i štítek. */
export function pctTone(pct: number): { bar: string; badge: string } {
  if (pct >= 80) return { bar: 'bg-success', badge: 'bg-success-light text-success' };
  if (pct >= 50) return { bar: 'bg-warning', badge: 'bg-warning-light text-warning' };
  return { bar: 'bg-danger', badge: 'bg-danger-light text-danger' };
}

/** „A > B > C" → poslední článek (název dlaždice) a zbytek (drobný popisek). */
export function splitPath(path: string): { name: string; parent: string | null } {
  const parts = path.split('>').map((p) => p.trim());
  const name = parts.pop() ?? path;
  return { name, parent: parts.length ? parts.join(' › ') : null };
}
